export class EstadoCivilEntidade {
	public CD_ESTADO_CIVIL: string;
	public DS_ESTADO_CIVIL: string;
}
